










































import { Vue, servicesURL } from "../../constants/constants";
import { genericErrorsEnum } from "../../models/basket.model";
import { staticContent } from "../../localisation/detect-lang";

import EventBus from "../../eventBus";
export default Vue.component("credit-cards-list", {
  data() {
    return {
      servicesURL,
      staticContent,
      genericErrorsEnum,
    };
  },
  props: {
    ispromo: false,
    fromTopup: false
  },
  computed: {
    basket() {
      return this.$store.state.basket;
    },
    creditCards() {
      return this.$store.state.creditCards;
    },
    promoForm() {
      return this.$store.state.promoForm;
    },
    topup() {
      return this.$store.state.topup;
    },
  },
  methods: {
    updatePaymentCard(carduuid) {
      if (this.fromTopup) {
        this.$store.commit("updateTopupPaymentCard", carduuid);
      } else if (!this.ispromo) {
        this.$store.commit("updateBasketPaymentCard", carduuid);
        if (navigator.onLine) {
          this.$store
            .dispatch("UPDATE_BASKET_PAYMENT_METHOD", {
              method: this.basket.payment.paymentTypeEnum.CREDIT_CARD,
              carduuid: carduuid,
            })
            .catch(() => {
              this.$root.handleGenericErrors(genericErrorsEnum.generic);
            });
        } else {
          this.$root.handleGenericErrors(genericErrorsEnum.internet);
        }
      } else {
        this.$store.commit("updateGiftingPaymentCard", carduuid);
      }
    },
  },
});
